var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mic_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1705_6074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1705_6074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mic_off_2",
    d: "M17.7492 14.95L16.2992 13.5C16.4326 13.2667 16.5534 13.025 16.6617 12.775C16.7701 12.525 16.8492 12.2583 16.8992 11.975C16.9659 11.6917 17.0951 11.4583 17.2867 11.275C17.4784 11.0917 17.7159 11 17.9992 11C18.2826 11 18.5159 11.1 18.6992 11.3C18.8826 11.5 18.9576 11.7417 18.9242 12.025C18.8409 12.5583 18.6992 13.0708 18.4992 13.5625C18.2992 14.0542 18.0492 14.5167 17.7492 14.95ZM14.7992 11.95L8.99922 6.15V5C8.99922 4.16667 9.29089 3.45833 9.87422 2.875C10.4576 2.29167 11.1659 2 11.9992 2C12.8326 2 13.5409 2.29167 14.1242 2.875C14.7076 3.45833 14.9992 4.16667 14.9992 5V11C14.9992 11.1833 14.9784 11.35 14.9367 11.5C14.8951 11.65 14.8492 11.8 14.7992 11.95ZM10.9992 20V17.9C9.46589 17.7 8.15339 17.0583 7.06172 15.975C5.97005 14.8917 5.30755 13.575 5.07422 12.025C5.04089 11.7417 5.11589 11.5 5.29922 11.3C5.48255 11.1 5.71589 11 5.99922 11C6.28255 11 6.52005 11.0958 6.71172 11.2875C6.90339 11.4792 7.03255 11.7167 7.09922 12C7.33255 13.1667 7.91172 14.125 8.83672 14.875C9.76172 15.625 10.8159 16 11.9992 16C12.5659 16 13.1034 15.9125 13.6117 15.7375C14.1201 15.5625 14.5826 15.3167 14.9992 15L16.4242 16.425C15.9409 16.8083 15.4117 17.1292 14.8367 17.3875C14.2617 17.6458 13.6492 17.8167 12.9992 17.9V20C12.9992 20.2833 12.9034 20.5208 12.7117 20.7125C12.5201 20.9042 12.2826 21 11.9992 21C11.7159 21 11.4784 20.9042 11.2867 20.7125C11.0951 20.5208 10.9992 20.2833 10.9992 20ZM19.0992 21.9L2.09922 4.9C1.91589 4.71667 1.82422 4.48333 1.82422 4.2C1.82422 3.91667 1.91589 3.68333 2.09922 3.5C2.28255 3.31667 2.51589 3.225 2.79922 3.225C3.08255 3.225 3.31589 3.31667 3.49922 3.5L20.4992 20.5C20.6826 20.6833 20.7742 20.9167 20.7742 21.2C20.7742 21.4833 20.6826 21.7167 20.4992 21.9C20.3159 22.0833 20.0826 22.175 19.7992 22.175C19.5159 22.175 19.2826 22.0833 19.0992 21.9Z",
    fill: "#DE1135"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMicOff);
export default __webpack_public_path__ + "static/media/red_mic_off.960dbaf4054c61782d83a322ade0faab.svg";
export { ForwardRef as ReactComponent };